import React from "react";
import { RevenueVsExpensesChart } from "./RevenueVsExpensesChart";
import { RevenueVsExpensesInsights } from "./RevenueVsExpensesInsights";
import { Skeleton } from "../shared/Skeleton";
import type { RevenueVsExpensesChartProps } from "./RevenueVsExpensesChart";
import type { RevenueVsExpensesInsightsProps } from "./RevenueVsExpensesInsights";

export interface RevenueVsExpensesCardProps {
  chart: RevenueVsExpensesChartProps;
  insights: RevenueVsExpensesInsightsProps;
  /** When true, shows a loader in the insights panel instead of stub/dummy content */
  insightsLoading?: boolean;
  /** When set, shows an error state in the insights panel */
  insightsError?: string | null;
}

export function RevenueVsExpensesCard({
  chart,
  insights,
  insightsLoading = false,
  insightsError = null,
}: RevenueVsExpensesCardProps) {
  return (
    <div className="flex w-full min-w-0 max-w-full gap-4 rounded-lg border border-solid border-neutral-200 bg-white px-6 py-6 sm:px-8 sm:py-8 shadow-sm items-stretch overflow-hidden min-h-[360px]">
      <div className="flex min-w-0 flex-1 basis-0 overflow-hidden self-stretch">
        <RevenueVsExpensesChart {...chart} />
      </div>
      <div className="flex min-w-0 flex-shrink-0 basis-80 max-w-sm self-stretch">
        {insightsLoading ? (
          <div className="flex w-full h-full flex-none flex-col items-start gap-4 rounded-r-lg border-l-4 border-solid border-neutral-200 bg-neutral-50 px-4 py-6 sm:px-6 min-w-0">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <div className="flex items-center gap-2 mt-auto">
              <Skeleton className="h-2 w-2 rounded-full" />
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        ) : insightsError ? (
          <div
            className="flex w-full h-full flex-none flex-col items-start gap-2 rounded-r-lg border-l-4 border-solid border-error-200 bg-error-50 px-4 py-6 sm:px-6 min-w-0"
            role="alert"
          >
            <span className="text-caption-bold font-caption-bold text-error-700">
              Error loading insights
            </span>
            <span className="text-caption font-caption text-error-700">
              {insightsError}
            </span>
          </div>
        ) : (
          <RevenueVsExpensesInsights {...insights} />
        )}
      </div>
    </div>
  );
}
